import { useState, useEffect, useContext, useCallback } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom'

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
// import { FaEye } from 'react-icons/fa';

import { UserContext } from '../../context/user-context'

import './attendees.css'

export default function Attendees() {
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [attendees, setAttendees] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const { userToken, user } = useContext(UserContext)

  useEffect(() => {
    fetchAttendees(page);
  }, [page]);

  const fetchAttendees = useCallback(async (page) => {
    try {
      setLoading(true);
      const time = new Date().getTime();
      const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/wp-json/gnetwork/v1/brands/${user?.ID}/attendance?timestamp=${time}`, {
        headers: {
          'Authorization': 'Basic ' + btoa(user?.user_login + ":" + userToken),
          'Content-Type': 'multipart/form-data'
        },
      });
      if (res.data) {
        console.log(res.data)
        setAttendees(res.data.attendance);
        setLoading(false);
      }
    } catch (error) {
      // setError('Failed to fetch orders');
      console.error(error);
      setLoading(false);
    }
  }, [user?.user_login, userToken]);

  /* no paging yet
  useEffect(() => {
    const handleScroll = () => {
      if (
        window.innerHeight + document.documentElement.scrollTop >=
        document.documentElement.offsetHeight - 100 // Trigger near the bottom
      ) {
        if (!loading) {
          setPage((prevPage) => prevPage + 1); // Load the next page
        }
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [loading]);
  */

  const filteredAttendees = attendees.filter(function(attendee) {
    const s = searchQuery.toLowerCase()
    if (attendee.first_name.toLowerCase().includes(s)) {
      return true;
    }
    if (attendee.last_name.toLowerCase().includes(s)) {
      return true;
    }
    if (attendee.occupation && attendee.occupation.toLowerCase().includes(s)) {
      return true;
    }
    return false;
  });

  return (
    <Container>
      <Row className="mb-3">
        <Col md="auto">
          <h1 className="m-0">Attendees</h1>
        </Col>
        <Col>
         <input
            type="text"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            placeholder="Filter attendees"
            className="attendees-search"
          />
        </Col>
      </Row>
      {(loading) && (
        <Row>
          <Col>
            <p>Loading...</p>
          </Col>
        </Row>
      )}
      {(!loading && attendees.length == 0) && (
        <Row className="text-center">
          <Col>
            <h4>No one has RSVP'd or bought a ticket to one of your events yet.</h4>
          </Col>
        </Row>
      )}
      {(!loading && filteredAttendees.length > 0) && (
        <div className="attendees-listing">
          {filteredAttendees.map((attendee, index) => (
            <div className={`attendee-item ${loading ? 'loading-skeleton' : ''}`} key={attendee.user_id}>
              <Row>
                <Col xs="auto" className="attendee-item_img-wrap">
                  <img className="attendee-item_img" src={attendee?.image} alt={attendee.first_name} loading="lazy"/>
                </Col>
                <Col className="attendee-item_details">
                  <h5 className="m-0">{attendee.first_name} {attendee.last_name}</h5>
                  <span className="d-block text-silver">{attendee.occupation}</span>
                </Col>
                <Col className="attendee-item_view-col">
                  <Link to={'/attendees/' + attendee.user_id} className="btn btn-outline-light">View Details</Link>
                </Col>
              </Row>
            </div>
          ))}
        </div>
      )}
    </Container>
  );
}
